<template>
  <!-- Custom button that wraps PrimeVue Button -->
  <Button
    :label="label"
    :class="buttonClass"
    :style="buttonStyle"
    :disabled="isDisabled"
    :type="type"
    @click="handleClick"
    :icon="icon"
    class="mobile-button"
    :icon-pos="iconPosition"
    :icon-class="iconClass"
  />
</template>

<script setup>
import { computed } from "vue";
import Button from "primevue/button";

const props = defineProps({
  label: {
    type: String,
    default: "Click Me",
  },
  buttonClass: {
    type: String,
    default: "",
  },
  variant: {
    type: String,
    default: "black",
  },
  buttonStyle: {
    type: Object,
    default: () => ({}),
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: "",
  },
  iconPosition: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "",
  },
  iconClass: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["click"]);

const handleClick = (event) => {
  if (props.isDisabled) return;
  emit("click", event);
};

const buttonClass = computed(() => {
  let variantClass = "";
  switch (props.variant) {
    case "secondary":
      variantClass = "secondary-button";
      break;
    case "primary":
      variantClass = "primary-button";
      break;
    case "tertiary":
      variantClass = "tertiary-button";
      break;
    case "tab":
      variantClass = "tab-button";
      break;
    case "static":
      variantClass = "static-button";
      break;
    case "white":
      variantClass = "white-button";
      break;
    case "error":
      variantClass = "error-button";
      break;
    case "black":
    default:
      variantClass = "black-button";
      break;
  }
  return `btn ${variantClass} ${props.buttonClass}`;
});
</script>

<style scoped>
.btn,
.btn:hover {
  font-variation-settings: "wght" 500;
  border-radius: 10px;
  padding: 12px 24px;
  cursor: pointer;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.primary-button {
  background-color: var(--an-primary) !important;
  color: var(--an-white) !important;
}

.secondary-button {
  background-color: var(--an-secondary) !important;
  color: var(--an-white) !important;
}

.tertiary-button {
  background-color: var(--an-tertiary) !important;
  color: var(--an-white) !important;
}

.static-button {
  background-color: transparent !important;
  color: var(--an-gray) !important;
  border: 1px solid var(--an-gray) !important;
}
.white-button {
  background-color: var(--an-white) !important;
  color: var(--an-text-primary) !important;
}

.tab-button {
  background-color: var(--an-background-light) !important;
}

.black-button {
  background-color: var(--an-black) !important;
  color: var(--an-white) !important;
}

.error-button {
  background-color: var(--an-error) !important;
  color: var(--an-white) !important;
}

@media (max-width: 768px) {
  .mobile-button {
    font-size: 15px;
    padding: 10px 15px;
  }
}
</style>
